/**
 * Shared response-shape helpers for the API.
 *
 * The backend is migrating from the legacy `{ code, message, ... }` envelope
 * to the new `{ success, data, message }` shape (Q12). New endpoints already
 * carry both keys for the duration of the migration; old endpoints still
 * return only `code`. Routing every call-site through `isSuccess(res)` lets
 * us drop the legacy half cleanly when the migration completes.
 */

/**
 * True when the response indicates a successful call, regardless of envelope:
 *   - new shape: `success === true`
 *   - legacy shape: `code === "0000"`
 */
export const isSuccess = (res) =>
  Boolean(res) && (res.success === true || res.code === "0000");
